import { call, put, takeLatest, all, fork, takeEvery } from 'redux-saga/effects';
import { setBookingFilters, setBookingsViewType, setSelectedBooking } from './actions';
import { GET_BOOKING_FILTERS, GET_BOOKINGS_VIEW_TYPE, GET_SELECTED_BOOKING, SET_BOOKING_FILTERS } from './actionTypes';

function* updateBookingFilters({ payload }) {
	yield put(setBookingFilters(payload));
}

function* updateSelectedBooking({ payload }) {
	yield put(setSelectedBooking(payload));
}

function* updateBookingsViewType({ payload }) {
	yield put(setBookingsViewType(payload));
}

function* watchFilterChanges() {
	yield takeLatest(GET_BOOKING_FILTERS, updateBookingFilters);
	yield takeLatest(GET_SELECTED_BOOKING, updateSelectedBooking);
	yield takeLatest(GET_BOOKINGS_VIEW_TYPE, updateBookingsViewType);
}

export default function* rootSaga() {
	yield all([fork(watchFilterChanges)]);
}
